import React, { useCallback, useEffect, useState } from 'react'
import { partition } from 'lodash'

import {
  MultiSelectInput,
  MultiSelectInputProps,
  SelectOptionType,
} from '@revolut-internal/ui-kit'

export function MultiSelectWithSelectedOnTop<
  Value extends string | number,
  Option extends SelectOptionType<Value>,
>(props: MultiSelectInputProps<Value, Option>) {
  const { options, value, onToggle, ...rest } = props

  const [isOpen, setOpen] = useState(false)
  const [sortedOptions, setSortedOptions] = useState(options)

  useEffect(() => {
    if (!isOpen && options) {
      const selectedSet = new Set(value)

      const [selectedOptions, unselectedOptions] = partition(
        options,
        option => option.value && selectedSet.has(option.value),
      )

      setSortedOptions([...selectedOptions, ...unselectedOptions])
    }
  }, [isOpen, value, options])

  const handleToggle = useCallback(
    (open: boolean) => {
      setOpen(open)

      onToggle?.(open)
    },
    [onToggle],
  )

  return (
    <MultiSelectInput
      {...rest}
      options={sortedOptions}
      value={value}
      onToggle={handleToggle}
    />
  )
}
